module.exports = __webpack_public_path__ + "static/media/introduction-02.2da27ad8.png";